<template>
  <div class="flex-0 flex-shrink-0 py-2 px-4 bg-black text-xs text-gray-200">
    
    <div class="items-center justify-between hidden md:flex">

      <div class="flex items-end">

        <router-link :to="{ name: 'home' }">
          <div class="mt-1 md:mt-0">
            <div><img :src="logoUrl" style="height:21px" /></div>
          </div>
        </router-link>
        
        <PVersionChecker v-slot="{ version }">
          <div class="text-gray-500 leading-none ml-1 hidden md:block">APP: {{ version }} | {{ info }}</div>  
        </PVersionChecker>

      </div>

      <div class="flex items-center space-x-4 mt-2 md:mt-0" v-if="user">

        <button
          class="focus:outline-none focus:text-white hover:text-white hover:underline focus:underline"
          @click="userSelectDialogVisible = true"        
        >          
          {{ customer.name }}, {{ location.name }}, {{ user.name }}
        </button>

        <div class="flex space-x-2" v-if="interCompanies.length > 0">
          <a 
            class="focus:outline-none hover:underline focus:underline"          
            :href="interCompany.url"
            v-for="(interCompany, index) in interCompanies" :key="index"
          >
            {{ interCompany.companyCountry }}
        </a>

        </div>

        <PLanguagePicker />

        <button
          class="focus:outline-none focus:text-white hover:text-white hover:underline focus:underline"
          @click.prevent="onLogout"
          v-html="$tk('PUserContext.Logout')"
        ></button>

      </div>

    </div>

    <div class="flex items-center justify-between md:hidden">

        <router-link :to="{ name: 'home' }">          
            <img :src="logoUrl" style="height:21px" />          
        </router-link>

        <div class="flex items-center space-x-4">
          <PLanguagePicker />
          <MenuDropdown 
            :invert="true" 
            :mobileLinks="mobileLinks" 
            @userClick="userSelectDialogVisible = true"
          />
        </div>

    </div>
      
    <PUserSelectDialog 
      v-if="userSelectDialogVisible" 
      @close="userSelectDialogVisible = false"
    />
    
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { get } from "lodash"
import { reportLevel } from "../enums"
import PUserSelectDialog from "@/dialogs/PUserSelectDialog"
import PLanguagePicker from "./PLanguagePicker"
import MenuDropdown from "@/components/MenuDropdown"
import { getTheme } from "@/config"

const theme = getTheme()

export default {
  name: "UserContext",
  components: {
    PUserSelectDialog,
    PLanguagePicker,  
    MenuDropdown  
  },
  props: ["mobileLinks"],
  data() {
    return {
      userSelectDialogVisible: false
    }
  },
  computed: {
    ...mapGetters([
      "status",
      "customer", 
      "location", 
      "user", 
      "interCompanies",
      "packageVersion"
    ]),
    canChangeContext () {
      return (
        this.user.isGlobalAdmin ||
        this.user.isCustomerAdmin ||
        this.user.reportLevel >= reportLevel.LOCATION
      )
    },
    info () {
      return get(this.status, "info", "")
    },
    logoUrl () {
      return theme.logoWhite      
    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout")
    }
  }
}
</script>
